<template lang="pug">
	.input-select-control(:class="{'change-process': changedValue !== null, [theme]: true, 'not-editable': options.editable === false, disabled: disabled}")
		.input-title(v-if="title") {{title}}
		.number-input
			label(v-on:wheel="processChangeValueByMouseWheel($event)")
				input.form-control.form-control-sm(:value="getDisplayedValue()" v-on:keydown="startChangeValueByKeyPress($event)" v-on:keyup="changeValueByInput($event.target.value, $event, false)" v-on:change="changeValueByInput($event.target.value, $event)" v-on:focus="blockUpdate()" v-on:blur="unblockUpdate()" :disabled="disabled || options.editable === false")
			.drop-icon.fa.fa-caret-down(ref="drop-icon" v-on:click="openMenu($event)")
			.open-menu-in-disabled-state(v-on:click="openMenu($event)")
</template>

<script>

	import Screen 							from './../../../mixins/screen'

	export default {
		name: 'InputSelect',
		mixins: [Screen],
		screen: {
			updateOn: [],
			events: {}
		},
		components: {},
		props: ['title','default','value','values','type','disabled','disabledValue','options','min','max','step','theme'],
		data() {

			this.element = null;

			this.keyPressProcess = null;

			return {
				showed: true,
				changedValue: null,
				position: {
					right: 0,
					bottom: 0
				}
			};

		},
		mounted() {

			window.addEventListener("keydown", e => {

				if (this.keyPressProcess) {

					if (e.keyCode === 16) this.keyPressProcess.shiftKey = true;

				}

			});

			window.addEventListener("keyup", e => {

				if (this.keyPressProcess) {

					if (e.keyCode === 38 || e.keyCode === 40) this.stopChangeValueByKeyPress();
					if (e.keyCode === 16) this.keyPressProcess.shiftKey = false;

				}

			});

		},
		methods: {
			collectData() {

			},
			getValue() {

				let value = null;

				// console.log('getValue this.changedValue', this.changedValue, 'this.value', this.value, 'this.default', this.default);

				if (this.changedValue !== null && this.changedValue !== undefined) value = this.changedValue;
				else if (this.value !== null && this.value !== undefined) value = this.value;
				else value = this.default;

				value = this.restoreValueType(value);

				return value;

			},
			getDisplayedValue() {

				if (this.disabled && this.disabledValue) return this.disabledValue;

				let value = this.getValue();

				if (this.options.controlOptions?.percents) value = `${parseInt(value * 100)}%`;
				else if (this.options.changes && "accuracy" in this.options.changes) value = parseInt(value * Math.pow(10, this.options.changes.accuracy)) / Math.pow(10, this.options.changes.accuracy);

				if (this.options.displayedValueTransform) return this.options.displayedValueTransform(value);

				return value;

			},
			setValue(value, delay = 500) {

				this.changedValue = this.restoreValueType(value);

				this.$emit('input', this.changedValue);

				this.update();

				clearTimeout(this.sendTimeout);
				this.sendTimeout = setTimeout(() => {

					this.$emit('change', this.changedValue);

					//this.changedValue = null;

					this.update();

				}, delay);

			},
			processChangeValueByMouseWheel(e) {

				this.changeValueByStep(Math.sign(e.wheelDelta), e.shiftKey);

			},
			changeValueByInput(value, e = null) {

				if (!e || (e.keyCode !== 38 && e.keyCode !== 40)) {

					if (this.type === 'number') {

						// Если вводить значение "0.3" то при написании второго символа "0." код обновляет поле ввода назад на "0" и становится невозможно ввести "0.3" поэтому пропустим тут обновление при временно невалидных значениях
						if (parseFloat(value) + '' !== value) return;

						value = parseFloat(value);

						if (!_.isNaN(value)) this.setValue(value);

					} else {

						this.setValue(value);

					}

				}

			},
			startChangeValueByKeyPress(e) {

				if (e.keyCode === 38 || e.keyCode === 40) {

					if (!this.keyPressProcess) {

						this.keyPressProcess = {
							increaser: e.keyCode === 40 ? -1 : 1,
							shiftKey: e.shiftKey
						};

						this.keyPressProcess.timeout = setTimeout(() => {

							this.changeValueByStep(this.keyPressProcess.increaser, this.keyPressProcess.shiftKey);

							this.keyPressProcess.interval = setInterval(() => {

								this.changeValueByStep(this.keyPressProcess.increaser, this.keyPressProcess.shiftKey);

							}, 50);

						}, 200);

						this.changeValueByStep(this.keyPressProcess.increaser, this.keyPressProcess.shiftKey);

					}

					e.preventDefault();

				}

			},
			stopChangeValueByKeyPress() {

				if (this.keyPressProcess) {

					clearTimeout(this.keyPressProcess.timeout);
					clearInterval(this.keyPressProcess.interval);

					this.keyPressProcess = null;

				}

			},
			changeValueByStep(increaser, shiftKey) {

				if (!this.options.changes) return;

				let newValue = this.getValue() + this.options.changes.step * increaser * (shiftKey ? 10 : 1);

				if (newValue < this.options.changes.min) newValue = this.options.changes.min;
				if (newValue > this.options.changes.max) newValue = this.options.changes.max;

				this.setValue(newValue);

			},
			restoreValueType(value) {

				if (this.type === 'number') return parseFloat(value);
				else if (this.type === 'string') return value + '';
				else return value;

			},
			blockUpdate() {

				// Запрещаем апдейт компонента пока фокус стоит в поле ввода информации
				this.updateBlocked = true;

			},
			unblockUpdate() {

				this.updateBlocked = false;

				// Пробуем через таймаут обновить компонент
				// Если updateBlocked к этому моменту всё ещё будет false то компонент обновится и отобразит новые клиентские данные
				// Это делается чтобы заблокировать обновление полей ввода пока пользователь не завершил их ввод
				// Без этого автообновления мешают печатать новые значения в полях типа coords
				clearTimeout(this.updateTimeout);
				this.updateTimeout = setTimeout(() => {

					this.update();

				}, 200);

			},
			openMenu(e) {

				if (this.disabled) return;

				Broadcast.call("Show InputSelectDropdown", [this.$refs["drop-icon"], this.values, {
					width: this.options.dropdownWidth,
					height: this.options.dropdownHeight,
					direction: this.options.dropdownDirection,
					align: this.options.dropdownAlign || this.options.align,
					callback: (data) => {

						// options.selectTransform - преобразование только значения, выбранного из меню (ручной ввод не изменяется), например ограничение максимумом
						this.setValue(this.options.selectTransform ? this.options.selectTransform(data.itemValue) : data.itemValue, 0);

					}
				}]);

			}
		}

	}
</script>

<style lang="sass">

	.input-select-control.dark-medium
		color: #f3f4f5
		display: flex
		flex-direction: row
		flex-wrap: nowrap
		align-items: center
		font-size: 0

		.input-title
			display: flex
			justify-content: right
			overflow: hidden
			text-overflow: ellipsis
			color: var(--secondary)
			font-size: 0.85rem
			padding-right: 0.5rem
			cursor: default
			user-select: none

		.number-input
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			color: rgba(255, 255, 255, 0.87)
			position: relative
			height: 30px
			border: 1px solid #23282c
			border-radius: 0.25rem
			background: #515b65

			&:focus
				outline: none
				box-shadow: none
				background: #515b65
				border: 1px solid rgba(255, 255, 255, 0.3)

			&:hover
				outline: none
				box-shadow: none
				background: #515b65
				border: 1px solid rgba(255, 255, 255, 0.3)

			label
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				margin: 0
				padding: 0

			input
				margin: 0
				width: calc(100% - 17px)
				height: 28px
				box-shadow: none
				padding: 0 5px
				margin: 0
				font-size: 14px
				transition: none
				border: none
				background-color: transparent

				&:focus
					outline: none
					box-shadow: none
					background: transparent
					border: none

				&:hover
					outline: none
					box-shadow: none
					background: transparent
					border: none

			.drop-icon
				position: absolute
				width: 25px
				height: 30px
				right: 0
				top: 0
				color: #e4e7ea
				font-size: 14px
				cursor: pointer
				text-align: center

				&:before
					position: absolute
					top: 7px
					right: 7px
					color: rgba(255,255,255,0.2)

			.drop-icon:hover

				&:before
					color: rgba(255,255,255,0.8)

			.open-menu-in-disabled-state
				display: none

	.input-select-control.dark-medium.change-process

		.title
			color: #20a8d8

	.input-select-control.dark-medium.not-editable

		.number-input

			.drop-icon:hover

				&:before

		.number-input:hover

			.drop-icon

				&:before
					color: rgba(255,255,255,0.8)

			.open-menu-in-disabled-state
				display: flex
				width: 100%
				height: 100%
				position: absolute
				left: 0
				top: 0
				cursor: pointer

	.input-select-control.dark-medium.disabled
		opacity: 0.4

		.number-input
			border: 1px solid rgba(0,0,0,0.3)

			.drop-icon
				visibility: hidden

			.open-menu-in-disabled-state
				display: none

		.number-input:hover

			.drop-icon

				&:before
					color: rgba(255,255,255,0.8)

			.open-menu-in-disabled-state
				display: none

</style>
